<template>
  <div class="identityCloudBox">
    <div class="digitalIdentity-container">
      <img src="@/assets/image/digitalCloud/digitalIdentity1.png"/>
      <div class="digitalIdentity-content">
        <h2 class="digitalCloud-title">可信数字身份平台</h2>
        <p>豸信身份认证服务与权威数据源合作，为客户提供可信、灵活的身份核验服务，采用国密算法保护身份信息，解决用户在网络中不同身份的应用，为企业和个人提供可信身份依据，促进数字身份在不同场景下的平滑流转与认可。</p>
      </div>
    </div>
    <div class="identityCloud-introduction">
      <div class="feature-box">
        <div class="feature-item">
          <h3><img src="@/assets/image/digitalCloud/digitalIdentity2.png"/>实名认证</h3>
          <p>支持个人身份认证/企业身份认证与意愿认证</p>
        </div>
        <div class="feature-item">
          <h3><img src="@/assets/image/digitalCloud/digitalIdentity3.png"/>身份管理与应用</h3>
          <p>身份认证通过后为用户颁发数字身份标识-数字证书</p>
        </div>
        <div class="feature-item">
          <h3><img src="@/assets/image/digitalCloud/digitalIdentity4.png"/>海外KYC</h3>
          <p>支持海外身份认证，满足跨境业务需求</p>
        </div>
      </div>

      <div class="verification-method">
        <h2 class="digitalCloud-title">多种核验方式</h2>
        <div class="verification-box">
          <div class="verification-item">
            <h3>企业</h3>
            <div class="verification-info">
              <dl>
                <dt>法定代表人本人认证</dt>
                <dd>提交企业工商或组织机构代码信息与法人信息，上传企业营业执照，法人通过人脸识别验证或者手机短信验证完成核验</dd>
              </dl>
              <dl>
                <dt>法定代表人授权</dt>
                <dd>提交企业工商或组织机构代码信息与法人信息，上传企业营业执照，法人通过小程序做人脸识别或者短信验证授权</dd>
              </dl>
              <dl>
                <dt>对公打款验证</dt>
                <dd>提交企业工商或组织机构代码信息等基本信息，上传企业营业执照，对公打款1元以下随机金额验证企业授权</dd>
              </dl>
              <dl>
                <dt>人工审核</dt>
                <dd>提交企业工商或组织机构代码信息等基本信息，上传企业营业执照，提交企业实名认证授权书，邮寄纸质资料到平台，平台进行人工审核</dd>
              </dl>
            </div>
          </div>
          <div class="verification-item">
            <h3>个人</h3>
            <div class="verification-info">
              <dl>
                <dt>人脸识别</dt>
                <dd>提交姓名、身份证号之后，录制人脸识别视频，进行公安公民身份信息真实性核实，人脸识别验证申请人意愿</dd>
              </dl>
              <dl>
                <dt>手机号认证</dt>
                <dd>提交姓名、身份证号、手机号，运营商核验公民身份信息真实性，短信验证码验证申请人意愿</dd>
              </dl>
              <dl>
                <dt>银行卡认证</dt>
                <dd>提交姓名、身份证号、银行卡号、银行预留手机号，查询银联核验信息真实性，短信验证码验证申请人意愿</dd>
              </dl>
              <dl>
                <dt>组合认证</dt>
                <dd>组合认证支持手机号+人脸识别组合认证、银行卡+人脸识别组合认证的认证方式，认证方式更加严谨</dd>
              </dl>
              <dl>
                <dt>人工审核</dt>
                <dd>提交姓名、身份证件、证件号码、身份证头像面和国徽面照片、申请人手势照片，平台进行人工审核</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div class="feature-introduction">
        <h2 class="digitalCloud-title">身份管理与应用</h2>
        <div class="manage-applications">
          <div class="manage-item">
            <img src="@/assets/image/digitalCloud/digitalIdentity5.png"/>
            <dl>
              <dt>企业/个人身份认证</dt>
              <dd>通过多种实名认证与意愿认证方式校验企业/个人身份的真实性与真实意愿，颁发数字证书</dd>
            </dl>
          </div>
          <div class="manage-item">
            <img src="@/assets/image/digitalCloud/digitalIdentity6.png"/>
            <dl>
              <dt>身份认证记录管理</dt>
              <dd>用户身份认证、应用过程记录留痕，用户行为可追溯、可证明</dd>
            </dl>
          </div>
          <div class="manage-item">
            <img src="@/assets/image/digitalCloud/digitalIdentity7.png"/>
            <dl>
              <dt>身份应用</dt>
              <dd>扫码签章：支持通过二维码扫描方式对PDF文件进行签章</dd>
              <dd>签名加密：支持采用安全存储的密钥对数据进行签名、验签、加密、解密</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div class="product-box">
      <h2 class="digitalCloud-title">产品优势</h2>
      <div class="product-advantages">
        <div class="product-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity9.png"/>
          <dl>
            <dt>权威的认证方式</dt>
            <dd>公安、银行、通信运营商、国家企业信息查询平台等权威认证数据源，并提供多种意愿认证方式，杜绝身份造假和冒用</dd>
          </dl>
        </div>
        <div class="product-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity10.png"/>
          <dl>
            <dt>安全可靠</dt>
            <dd>提供多种安全、可靠的活体检测方式，实时检测当前设备的风险等级，有效拦截照片、视频、3D模型、摄像头劫持等多种攻击类型，为业务提供安全可靠的认证环境</dd>
          </dl>
        </div>
        <div class="product-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity11.png"/>
          <dl>
            <dt>服务灵活</dt>
            <dd>支持混合、公有部署模式，可根据行业特性和业务要求使用不同的部署模式，产品功能也可根据需求灵活组合</dd>
          </dl>
        </div>
        <div class="product-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity12.png"/>
          <dl>
            <dt>配套完善</dt>
            <dd>提供人脸核身的基础检测和识别服务，以及数据统计、验证记录查询、人工审核等服务，方便客户及时响应验证中的e问题，形成服务闭环</dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="system-integration">
      <h2 class="digitalCloud-title">系统集成</h2>
      <div class="page-content">
        <h5>提供页面版本和API版本两套方案，灵活匹配不同场景，兼容Web、H5、小程序</h5>
        <h3>页面版本</h3>
        <p>支持兼容Web端、H5移动端以及支持中英文切换，包含完整的认证流程，基于前端认证组件模块，多种意愿认证方式及顺序按需选择，组件模板支持平台自定义CSS样式，满足不同系统的UI风格，只需一次集成，认证方式和认证等级灵活可选，扩展方便</p>
        <h4>多端兼容</h4>
        <div class="multiterminal">
          <img src="@/assets/image/digitalCloud/digitalIdentity13.png"/>
          <img src="@/assets/image/digitalCloud/digitalIdentity14.png"/>
          <img src="@/assets/image/digitalCloud/digitalIdentity15.png"/>
        </div>
      </div>
      <div class="api-version">
        <h3>API版本</h3>
        <p>灵活组合调用，满足用户的个性化需求</p>
        <ol>
          <li>信息比对</li>
          <li>人脸识别</li>
          <li>手机号认证</li>
          <li>银行卡认证</li>
          <li>证件OCR</li>
          <li>法人认证</li>
          <li>人工审核</li>
          <li>法人授权</li>
          <li>对公打款</li>
          <li>组合认证</li>
          <li>认证查询</li>
          <li>数字证书</li>
        </ol>
      </div>
    </div>

    <div class="overseas-kyc">
      <h2 class="digitalCloud-title">海外KYC支持国外用户身份认证</h2>
      <div class="kyc-data">
        <dl>
          <dt>识别全球证件</dt>
          <dd>6000<span>+</span></dd>
        </dl>
        <dl>
          <dt>信息准确率</dt>
          <dd>99.95<span>%</span></dd>
        </dl>
        <dl>
          <dt>认证平均时长</dt>
          <dd>10<span>s</span></dd>
        </dl>
        <dl>
          <dt>认证流程保存</dt>
          <dd>全程</dd>
        </dl>
      </div>
      <div class="overseas-info">
        <dl>
          <dt>满足合规监管要求</dt>
          <dd>遵守反洗钱AML法规和KYC要求，防止欺诈和防止身份盗用，符合全球的认证要求和标准规范，提供专业可信的认证服务</dd>
        </dl>
        <dl>
          <dt>风险管理</dt>
          <dd>通过了解客户，企业能够识别潜在的风险，例如信用风险、欺诈风险以及客户相关的法律和声誉风险，有助于企业制定相应的风险管理策略以减少损失</dd>
        </dl>
        <dl>
          <dt>客户识别与验证</dt>
          <dd>KYC流程包括验证客户提供的个人信息、如姓名、地址、出生日期、身份证明等，有助于确保企业与真实、合法的个体进行交易进而防止欺诈行为</dd>
        </dl>
        <dl>
          <dt>提升用户体验</dt>
          <dd>通过有效的KYC流程，企业可以更好地理解客户需求和偏好，从而提供更个性化的服务，提高客户满意度和忠诚度，增强客户关系</dd>
        </dl>
      </div>
    </div>

    <div class="application-box">
      <h2 class="digitalCloud-title">应用场景</h2>
      <div class="application-scenarios">
        <div class="scenarios-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity18.png"/>
          <div class="scenarios-info">
            <h3>电子合同</h3>
            <p>对电子合同等文件签署前进行权威身份数据源比对认证，采用数字证书标识身份，签署时意愿认证，保障身份及意愿的真实性，对文件签署等行为进行全程留存，保障各方权益及纠纷快速解决</p>
          </div>
        </div>
        <div class="scenarios-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity19.png"/>
          <div class="scenarios-info">
            <h3>电子招投标</h3>
            <p>对电子招投标场景中的投标方、招标方、专家等身份信息进行核验，并颁发数字证书作为数字身份标识，核验后可进行标书签名、验签、加密、解密等操作，确保招标、投标中操作人、操作时间、操作行为等全过程记录真实，用户不可否认</p>
          </div>
        </div>
        <div class="scenarios-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity20.png"/>
          <div class="scenarios-info">
            <h3>跨境支付</h3>
            <p>为东南亚的跨境业务公司提供在转账汇款、线上大额支付、绑卡、充值、换绑环节的eKYC能力，为其业务的安全运营提供技术支撑以及高效保障，有效对抗黑灰产攻击，保障用户账号的资金安全</p>
          </div>
        </div>
        <div class="scenarios-item">
          <img src="@/assets/image/digitalCloud/digitalIdentity21.png"/>
          <div class="scenarios-info">
            <h3>物流</h3>
            <p>物流涉及司机、车主、发货方、收货方等众多角色，通过数字身份认证与业务过程留痕，发生代签时，身份可做到可追溯，实现全链条存症，在发生纠纷时，能有效的划分责任边界</p>
          </div>
        </div>
      </div>
    </div>

    <div class="partnership">
      <h2 class="digitalCloud-title">客户案例</h2>
      <div class="clearfix">
        <div class="customer" v-for="item in 5" :index="item" :key="item">
          <img :src="require('@/assets/image/digitalCloud/partners' + item + '.png')"/>
        </div>
      </div>
    </div>

    <v-networkSecurity />
  </div>
</template>

<script>
import networkSecurity from "@/components/networkSecurity.vue";
export default {
  components:{
    'v-networkSecurity':networkSecurity
  }
} 
</script>

<style lang="scss" scoped>
.identityCloudBox{
  width: 7.5rem;
  background: #fff;
  // padding: 0 0 1.53rem;
  box-sizing: border-box;
}
.digitalIdentity-container{
  width: 100%;
  height: 7.2rem;
  position: relative;
  img{
    width: 100%;
  }
}
.digitalIdentity-content{
  position: absolute;
  bottom: 0;
  left: .24rem;
  width: calc(100% - .48rem);
  background: #F8FBFF;
  box-shadow: 4px 4px 8px 0px #08285E12;
  border-radius: 8px;
  padding: .4rem .48rem .26rem;
  box-sizing: border-box;
  opacity: 0.8;
  p{
    padding-top: .2rem;
    font-size: .282rem;
    line-height: .48rem;
    color: #1E1E1E;
  }
}
.digitalCloud-title{
  font-weight: 500;
  font-size: .4rem;
  line-height: .56rem;
  text-align: center;
  color: #1E1E1E;
}
.identityCloud-introduction{
  padding: 0 .24rem;
}
.feature-box{
  padding: .32rem 0;
}
.feature-item{
  width: 100%;
  height: 2.16rem;
  border-radius: 8px;
  background: url('~@/assets/image/digitalCloud/digitalIdentity8.png') center center no-repeat;
  margin-bottom: .32rem;
  padding: .48rem .18rem;
  box-sizing: border-box;
  img{
    width: .64rem;
    margin-right: .16rem;
  }
  h3{
    font-weight: 500;
    font-size: .34rem;
    line-height: .64rem;
    color: #262626;
    margin-bottom: .16rem;
  }
  p{
    font-size: .28rem;
    line-height: .4rem;
    color: #262626;
  } 
}
.verification-item{
  margin-top: .32rem;
  border-radius: .24rem;
  box-shadow: 0px 4px 16px 0px #2375DB14;
  overflow: hidden;
  background: url('~@/assets/image/digitalCloud/digitalIdentity16.png') -0.24rem -0.24rem no-repeat;
  background-size: 115% 110%;
  h3{
    background: linear-gradient(90deg, #EBF4FF 0%, #E6EDFF 100%);
    font-weight: 500;
    font-size: .34rem;
    line-height: .8rem;
    color: #262626;
    text-align: center;
  }
}
.verification-info{
  padding: .48rem .32rem;
  box-sizing: border-box;
  dl{
    margin-bottom: .4rem;
  }
  dl:last-child{
    margin-bottom: 0;
  }
  dt{
    padding-left: .28rem;
    position: relative;
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #1E1E1E;
    &::before{
      content: '';
      width: .12rem;
      height: .12rem;
      border-radius: .12rem;
      background: #1E1E1E;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
  dd{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
    margin-top: .16rem;
  }
}
.feature-introduction{
  padding: .64rem 0;
}
.manage-applications{
  position: relative;
  margin-top: .48rem;
  &::before{
    content: '';
    width: .04rem;
    height: 5.24rem;
    background: linear-gradient(180deg, #72A2FF 0%, rgba(114, 162, 255, 0) 100%);
    position: absolute;
    left: .26rem;
    top: .06rem;
  }
}
.manage-item{
  position: relative;
  padding-left: .9rem;
  margin-top: .48rem;
  &:first-child{
    margin-top: 0;
  }
  img{
    width: .56rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
  }
  dt{
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #1E1E1E;
  }
  dd{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
    margin-top: .16rem;
  }
}
.product-box{
  padding: .64rem .24rem;
  background: #F6FAFF;
}
.product-item{
  margin-top: .24rem;
  padding: .24rem .32rem .24rem .24rem;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  &:first-child{
    margin-top: .32rem;
  }
  img{
    width: .64rem;
    height: .64rem;
    margin-right: .2rem;
  }
  dt{
    font-weight: 500;
    font-size: .32rem;
    line-height: .64rem;
    color: #000000;
  }
  dd{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
  }
}
.system-integration{
  padding: .64rem .24rem .4rem;
  box-sizing: border-box;
}
.page-content{
  padding: .48rem 0.08rem 0;
  h5{
    font-weight: normal;
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
  }
  h3{
    margin: .16rem 0;
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #3C6EF1;
  }
  p{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
  }
  h4{
    margin: .24rem 0;
    font-weight: 500;
    font-size: .32rem;
    line-height: .52rem;
    color: #1E1E1E;
  }
}
.multiterminal{
  display: flex;
  img{
    width: .84rem;
    margin-right: .32rem;
  }
}
.api-version{
  h3{
    margin: .32rem 0 .16rem;
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #3C6EF1;
    padding: 0 0.08rem;
  }
  p{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
    padding: 0 0.08rem;
  }
  ol{
    margin-top: .16rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  li{
    width: 2.12rem;
    height: .8rem;
    background: #CDE0FF;
    border-radius: 4px;
    text-align: center;
    line-height: .8rem;
    font-size: .28rem;
    color: #1E1E1E;
    margin-bottom: .24rem;
  }
}
.overseas-kyc{
  padding: .48rem .24rem;
  box-sizing: border-box;
  background: url('~@/assets/image/digitalCloud/digitalIdentity16.png') top left no-repeat;
  background-size: 100% 100%;
}
.kyc-data{
  padding: .48rem .14rem 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  dl{
    text-align: center;
  }
  dt{
    font-size: .28rem;
    line-height: .4rem;
    color: #314974;
    margin-bottom: .16rem;
  }
  dd{
    font-size: .4rem;
    line-height: .56rem;
    background: linear-gradient(180deg, #81ABFF 7.14%, #1F5DF8 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }
  span{
    font-size: .28rem;
    background: linear-gradient(180deg, #2197FE 7.14%, #1F5DF8 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 500;
  }
}
.overseas-info{
  dl{
    border-radius: .24rem;
    background: #fff;
    margin-top: .24rem;
    padding: .32rem;
    box-sizing: border-box;
    box-shadow: 0px 4px 16px 0px #2375DB14;
    &:first-child{
      margin-top: .32rem;
    }
  }
  dt{
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #000000;
  }
  dd{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
    margin-top: .16rem;
  }
}
.application-box{
  padding: .64rem .24rem 0;
  box-sizing: border-box;
}
.application-scenarios{
  padding: .48rem 0 .64rem;
  overflow-y: auto;
  display: flex;
}
.scenarios-item{
  flex-shrink: 0;
  width: 6rem;
  margin-right: .24rem;
  border-radius: .24rem;
  background: #fff;
  box-shadow: 0px 4px 16px 0px #53567B14;
  &:last-child{
    margin-right: 0;
  }
}
.scenarios-info{
  padding: .4rem .32rem .56rem;
  box-sizing: border-box;
  h3{
    font-weight: 500;
    font-size: .32rem;
    line-height: .44rem;
    color: #1E1E1E;
  }
  p{
    font-size: .28rem;
    line-height: .4rem;
    color: #565656;
  }
}
.partnership {
  padding: 0.9rem 1.13rem 0.36rem;
  h2 {
    font-size: 0.48rem;
    font-weight: bold;
    color: #2d3b52;
    line-height: 0.67rem;
    text-align: center;
    margin-bottom: 0.48rem;
  }
}
.customer {
  width: 2.42rem;
  height: 1.44rem;
  margin: 0 0.4rem 0.4rem 0;
  float: left;
  background: #fdfdff;
  box-shadow: 0px 0.02rem 0.08rem 0px rgba(31, 37, 81, 0.11);
  border-radius: 0.04rem;
  &:nth-child(2n) {
    margin-right: 0;
  }
}
</style>